import { SxProps, Theme, Typography } from '@mui/material';
import { toSxArray } from 'src/utils/sx';

export const FORM_LABEL_WIDTH = 'min(40%, 140px)';

export const FormLabel = ({ label, sx }: { label?: string; sx?: SxProps<Theme> }) => {
  return (
    <Typography
      variant="subtitle2"
      sx={[
        {
          width: FORM_LABEL_WIDTH,
          flexShrink: 0,
          color: (theme) => theme.palette.custom.OV.sys.outline,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        ...toSxArray(sx),
      ]}
    >
      {label}
    </Typography>
  );
};
